import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { MaintenanceFinancialReviewSimpleEntriesRejectSchemaValidationSchema } from '../../../../schemas/forwardings/financialReview/simpleEntries/maintenanceFinancialReviewSimpleEntriesReject.schema'

interface UseMaintenanceFinancialReviewSimpleEntriesRejectProps {
  financialReviewEntryId: string | undefined
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>
}

export const useMaintenanceFinancialReviewSimpleEntriesReject = ({
  financialReviewEntryId,
  options,
}: UseMaintenanceFinancialReviewSimpleEntriesRejectProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation<void, AxiosError, MaintenanceFinancialReviewSimpleEntriesRejectSchemaValidationSchema>({
    mutationKey: ['maintenanceFinancialReviewSimpleEntriesReject'],
    mutationFn: (data) =>  privateAxios.put(`/maintenance/financial_review/simple_entries/${financialReviewEntryId}/reject`, {
      rejected_reason: data.rejected_reason
    }),
    ...options as any,
  })
}
